/**
 * This file was auto-generated by @gonfalon/openapi/generate.ts.
 * Do not make direct changes to the file.
 *
 * If you have any questions, reach out to #ask-frontend.
 */

import { mergeHeaders } from 'openapi-fetch';

import { getClient } from '../../internal/client';
import type { operations } from '../openapi';

export type InternalGetApplicationsByFlagPathParams = NonNullable<
  operations['internalGetApplicationsByFlag']['parameters']['path']
>;

export type InternalGetApplicationsByFlagQueryParams = NonNullable<
  operations['internalGetApplicationsByFlag']['parameters']['query']
>;

export interface Input extends InternalGetApplicationsByFlagPathParams {
  apiVersion?: string;
  query?: InternalGetApplicationsByFlagQueryParams;
}

export async function internalGetApplicationsByFlag(
  { apiVersion, query, ...path }: Input,
  { headers, signal }: { headers?: HeadersInit; signal?: AbortSignal } = {},
) {
  return getClient().GET('/internal/projects/{projectKey}/flags/{flagKey}/applications', {
    params: { path, query },
    headers: apiVersion ? mergeHeaders(headers, { 'LD-API-Version': apiVersion }) : headers,
    signal,
  });
}
